import Vue from 'vue';
import Buefy from 'buefy';
import Axios from 'axios';

import 'buefy/lib/buefy.min.css';
import './assets/css/main.css';

import App from './App';
import router from './router';

Vue.use(Buefy);

Vue.prototype.$http = Axios.create({
  baseURL: 'https://scarfs.trustcircle.co',
});

console.log = function log() {};

Vue.prototype.$temp = {
  get sessionCode() {
    return window.localStorage.scarfSessionId;
  },
  set sessionCode(value) {
    window.localStorage.scarfSessionId = value;
  },
  get testId() {
    return window.localStorage.scarfTestId;
  },
  set testId(value) {
    window.localStorage.scarfTestId = value;
  },
  endSession() {
    window.localStorage.removeItem('scarfSessionId');
  },
  checkIsSessionEnded() {
    this.$toast.open('Your session ended. Enter your organization code and try again.');
    this.$router.push('/');
  },
};

Vue.config.productionTip = false;

// const tld = process.env.tld;

Vue.prototype.$user = {
  get token() {
    return window.localStorage.trustcircle_token;
  },
  set token(value) {
    window.localStorage.trustcircle_token = value;
  },
  get user() {
    let user;
    if (window.localStorage.user) {
      try {
        user = JSON.parse(window.localStorage.user);
      } catch (e) {
        delete window.localStorage.user;
      }
      return user;
    }
    return user;
  },
  set user(obj) {
    window.localStorage.user = JSON.stringify(obj);
  },
  logout() {
    window.localStorage.removeItem('trustcircle_token');
    window.localStorage.removeItem('user');
  },
};

const patterns = {
  orgCodePattern: /^[a-zA-Z0-9]{8}$/,
};

Vue.prototype.$helpers = {
  pageOffset: 0,
  urlMainWebsite: process.env.urlMainWebsite,
  isOrgCode(val) {
    return patterns.orgCodePattern.test(val);
  },
  // login module
  isPassword(pwd) {
    return /^(.+){6,}/.test(pwd);
  },
  isEmail(email) {
    /* eslint-disable no-useless-escape */
    return /^[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/.test(email);
  },
  isAlias(alias) {
    return /^[a-zA-Z][a-zA-Z0-9]{4,}$/.test(alias);
  },
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js